import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Footer = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-83">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <footer className="border-t border-gray-200 pt-6 text-sm text-gray-600" data-id="element-84">
      <div className="flex items-start mb-6" data-id="element-85">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-16 h-16 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-86" />
        <div data-id="element-87">
          <p className="font-semibold mb-2" data-id="element-88">
            Amee de Bruijn is gediplomeerd hondengedragsconsultant niveau 5,
            opgeleid bij Calming Signs in Koningslust (2017).
          </p>
          <p data-id="element-89">
            "Natuurlijk heb ik ook verdere verdiepingscursussen als mensen nog
            meer willen leren, maar tijdens het{' '}
            {replaceWebinarWithLink('webinar')} probeer ik baasjes een stevige
            basis te geven."
          </p>
        </div>
      </div>
      <div className="text-xs border-t border-gray-200 pt-4 pb-2" data-id="element-90">
        <p className="text-gray-500 mb-3" data-id="element-91">
          Meta Advertising Disclaimer: Deze website maakt gebruik van Meta Pixel
          voor advertentiedoeleinden. Dit betekent dat informatie over uw bezoek
          aan deze website wordt gedeeld met Meta (Facebook) om gerichte
          advertenties te kunnen tonen. Door gebruik te maken van deze website
          gaat u akkoord met het gebruik van cookies en vergelijkbare
          technologieën voor analytische en advertentiedoeleinden. Deze pagina
          is een advertorial voor Stressless Dogs. Stressless Dogs is een
          onafhankelijk bedrijf en is op geen enkele wijze verbonden aan of
          onderdeel van Meta (voorheen Facebook). Deze advertentie wordt getoond
          via het Meta advertentieplatform, maar Meta is niet verantwoordelijk
          voor de inhoud of diensten aangeboden door Stressless Dogs.
        </p>
        <p className="text-center text-gray-500" data-id="element-92">
          © 2025 Communiceren met je hond. Alle rechten voorbehouden.
        </p>
      </div>
    </footer>;
};